// extracted by mini-css-extract-plugin
export default {"checkbox":"MemberWithdrawal_checkbox__+7Hql","checkmark1":"MemberWithdrawal_checkmark1__jZXgM"};